/** @flow */
import React from "react";
import classNames from "classnames";
import { Button } from "../button";
import Icons from "../icons";

type Props = $Exact<{
  className?: string,
  hideIcon?: boolean,
  title?: string | React$Node,
  subTitle?: string | React$Node,
  subTitleClassName?: string,
  wrapperClassName?: string,
  titleClassName?: string,
  rightLink?: string | React$Node,
  children: React$Node | void,
  collapsable?: boolean,
  isOpen?: boolean,
  onTitleClick?: Function,
  id?: string,
  compact?: boolean,
  active?: boolean,
  disabled?: boolean,
  collapseByButton?: boolean,
  defaultBorder?: boolean,
}>;

type OwnState = $Exact<{
  isOpen: boolean | null,
}>;
export class SectionComponent extends React.Component<Props, OwnState> {
  state = {
    isOpen: null,
  };

  componentDidMount() {
    if (this.props.collapsable && (this.props.isOpen === undefined || this.props.isOpen === null)) {
      //Adding support for internal isOpen, so you need to provide only the 'collapsible' prop
      this.setState({ isOpen: true });
    }
  }

  toggleCollapse = () => {
    if (this.state.isOpen !== null) {
      this.setState({
        ...this.state,
        isOpen: !this.state.isOpen,
      });
    }
  };

  onTitleClick = () => {
    return this.props.onTitleClick ? this.props.onTitleClick() : this.toggleCollapse();
  };

  get isCollapsed() {
    return !!(this.state.isOpen !== null ? this.state.isOpen : this.props.isOpen);
  }

  render() {
    return (
      <div
        id={this.props.id ? this.props.id : ""}
        className={classNames("section-container d-flex flex-column", this.props.className, {
          "default-border": this.props.defaultBorder,
          compact: this.props.compact,
          active: this.props.active,
          disabled: this.props.disabled,
        })}
      >
        {this.props.title ||
        (this.props.collapsable && !this.props.hideIcon) ||
        this.props.rightLink ? (
          <div
            className={classNames(
              "section-header d-flex",
              "d-flex justify-content-between align-items-center",
              {
                collapsable: !this.props.hideIcon && this.props.collapsable,
                "ml-0": this.props.collapseByButton,
              },
            )}
          >
            <div className={classNames("section-title flex-1", this.props.titleClassName)}>
              {!this.props.compact &&
                this.props.collapsable &&
                !this.props.hideIcon &&
                !this.props.collapseByButton &&
                (this.isCollapsed ? (
                  <span
                    className="material-icons font-size-30 mr-2 pointer"
                    onClick={this.onTitleClick}
                  >
                    expand_less
                  </span>
                ) : (
                  <span
                    className="material-icons font-size-30 mr-2 pointer"
                    onClick={this.onTitleClick}
                  >
                    expand_more
                  </span>
                ))}
              {this.props.title}

              {this.props.collapseByButton && (
                <div className="d-flex">
                  <Button
                    className={classNames("ml-2", {
                      primary: !this.isCollapsed,
                    })}
                    color="secondary"
                    materialIcon={this.isCollapsed ? "expand_less" : "expand_more"}
                  ></Button>
                </div>
              )}
            </div>
            {this.props.rightLink && (
              <div className="section-link d-flex justify-content-end">
                {this.props.rightLink}
                {this.props.compact && this.props.collapsable && !this.props.hideIcon && (
                  <Icons.StepTriangleIcon
                    onClick={this.onTitleClick}
                    className={`fill ${this.isCollapsed ? "" : "transform-rotate-90"}`}
                  />
                )}
              </div>
            )}
          </div>
        ) : null}
        {this.props.subTitle && (
          <div className={`font-size-15 ${this.props.subTitleClassName || ""}`}>
            {this.props.subTitle}
          </div>
        )}
        {this.props.children && (!this.props.collapsable || this.isCollapsed) && (
          <div
            className={`items-wrapper d-flex ${
              this.props.wrapperClassName ? this.props.wrapperClassName : ""
            }`}
          >
            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}

export default SectionComponent;
